<template>
  <el-cascader
    style="width: 100%"
    ref="cascader"
    :options="options"
    :props="local ? defaultProps : cityProps"
    v-model="dataRange"
    @change="handleChange"
    :clearable="clearable"
    :disabled="disabled"
    filterable
  ></el-cascader>
  <!--  :props="cityProps"-->
</template>

<script>
import { getAreaNext } from "@/views/commonApi";

export default {
  name: "Custom-Cascader",
  props: {
    provinceCode: {
      type: String,
      default: "",
    },
    cityCode: {
      type: String,
      default: "",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    districtCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      defaultProps: {
        value: "areaCode",
        label: "areaName",
        checkStrictly: true,
      },
      local: true,
      options: [],
      dataRange: [],
      cityProps: {
        lazy: true,
        checkStrictly: true, //可选择任意节点
        lazyLoad(node, resolve) {
          // setTimeout(() => {
          const nodes = [];
          let query = {};
          // 构造查询条件
          if (node.value) {
            query = {
              code: node.value,
            };
          }
          //查询接口
          getAreaNext(query).then((res) => {
            res.data.map((item) => {
              let obj = {
                value: item.areaCode,
                label: item.areaName,
                leaf: item.areaLevel === 1,
              };
              nodes.push(obj);
            });
            //重新加载节点
            resolve(nodes);
          });
          // }, 500);
        },
      },
    };
  },
  watch: {
    provinceCode(newValue) {
      this.dataRange = [];
      this.updateRange("provinceCode", newValue);
    },
    cityCode(newValue) {
      this.updateRange("cityCode", newValue);
    },
    districtCode(newValue) {
      this.updateRange("districtCode", newValue);
    },
  },
  created() {
    if (localStorage.getItem("area")) {
      this.local = true;
      this.options = JSON.parse(localStorage.getItem("area"));
    } else {
      this.local = false;
      this.defaultProps = this.cityProps;
    }
  },
  methods: {
    handleChange(value) {
      if (Array.isArray(value) && value.length === 0) {
        this.$emit("update:provinceCode", "");
        this.$emit("update:cityCode", "");
        this.$emit("update:districtCode", "");
      } else if (Array.isArray(value) && value.length === 1) {
        // 如果需要处理取消选择的情况
        this.$emit("update:provinceCode", value[0]);
        this.$emit("update:cityCode", "");
        this.$emit("update:districtCode", "");
      } else if (Array.isArray(value) && value.length === 2) {
        // 如果需要处理取消选择的情况
        this.$emit("update:provinceCode", value[0]);
        this.$emit("update:cityCode", value[1]);
        this.$emit("update:districtCode", "");
      } else if (Array.isArray(value) && value.length === 3) {
        // 如果需要处理取消选择的情况
        this.$emit("update:provinceCode", value[0]);
        this.$emit("update:cityCode", value[1]);
        this.$emit("update:districtCode", value[2]);
      }
    },

    updateRange(type, newValue) {
      // console.log("22222222222222222", type, newValue);
      const index = type === "provinceCode" ? 0 : type === "cityCode" ? 1 : 2;
      this.dataRange.push(newValue);
      // this.dataRange = [...this.dataRange];
      // this.dataRange[index] = newValue;
      // console.log(this.dataRange, "dddddddddddddddddddddddd");
    },
  },
};
</script>
